import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import Config from '@/utils/config'
import { User } from '@/models/User'

export const useUserStore = defineStore(
  'user',
  () => {
    // state
    const language = ref<string>(
      (typeof navigator != 'undefined' && Config.languages.find((language) => language === navigator.language.slice(0, 2 )))
        ? navigator.language.slice(0, 2) : 'de'
    )
    const sidebarVisible = ref(false)
    const token = ref<string | undefined>(undefined)
    const user = ref<User | undefined>(undefined)

    // getters
    const isLoggedIn = computed(() => !!token.value)
    const isSidebarVisible = computed(() => sidebarVisible.value)

    // setters
    const setLanguage = (lang: string) => {
      language.value = lang
      if (!import.meta.env.SSR)
        document.cookie = `language=${lang};path=/`
    }

    // actions
    const logout = () => {
      token.value = undefined
      user.value = undefined
    }
    const hideSidebar = () => {
      sidebarVisible.value = false
    }
    const showSidebar = () => {
      sidebarVisible.value = true
    }

    return {
      language,
      token,
      user,
      isLoggedIn,
      isSidebarVisible,
      hideSidebar,
      setLanguage,
      logout,
      showSidebar,
    }
  },
  { persist: !import.meta.env.SSR }
)
